import { supabase } from '../lib/supabase'
import {
  CRMCompany,
  CRMContact,
  CRMStage,
  CRMOpportunity,
  CRMActivity,
  CRMActivityType,
  CRMRelatedType,
  CRMSearchItem,
} from '../types/crm'

export const crmService = {
  // Companies
  async listCompanies(): Promise<CRMCompany[]> {
    const { data } = await supabase
      .from('crm_companies')
      .select('*')
      .order('created_at', { ascending: false })
    return (data || []) as CRMCompany[]
  },
  async upsertCompany(company: Partial<CRMCompany>): Promise<CRMCompany | null> {
    const { data, error } = await supabase
      .from('crm_companies')
      .upsert(company, { onConflict: 'id' })
      .select('*')
      .single()
    if (error) throw error
    return data as CRMCompany
  },
  async deleteCompany(id: string) {
    const { error } = await supabase.from('crm_companies').delete().eq('id', id)
    if (error) throw error
  },

  // Contacts
  async listContacts(): Promise<CRMContact[]> {
    const { data } = await supabase
      .from('crm_contacts')
      .select('*, company:company_id(*)')
      .order('created_at', { ascending: false })
    return (data || []) as any
  },
  async upsertContact(contact: Partial<CRMContact>): Promise<CRMContact | null> {
    const { data, error } = await supabase
      .from('crm_contacts')
      .upsert(contact, { onConflict: 'id' })
      .select('*')
      .single()
    if (error) throw error
    return data as CRMContact
  },
  async deleteContact(id: string) {
    const { error } = await supabase.from('crm_contacts').delete().eq('id', id)
    if (error) throw error
  },

  // Stages
  async getStages(): Promise<CRMStage[]> {
    const { data } = await supabase
      .from('crm_opportunity_stages')
      .select('*')
      .order('order_index', { ascending: true })
    return (data || []) as CRMStage[]
  },

  // Opportunities
  async listOpportunitiesByStage(stageId: string): Promise<CRMOpportunity[]> {
    const { data } = await supabase
      .from('crm_opportunities')
      .select('*, company:company_id(*), stage:stage_id(*)')
      .eq('stage_id', stageId)
      .order('created_at', { ascending: false })
    return (data || []) as any
  },
  async updateOpportunityStage(opportunityId: string, toStageId: string) {
    const { error } = await supabase
      .from('crm_opportunities')
      .update({ stage_id: toStageId })
      .eq('id', opportunityId)
    if (error) throw error
  },

  // Activities
  async listActivities(): Promise<CRMActivity[]> {
    const { data } = await supabase
      .from('crm_activities')
      .select('*')
      .order('created_at', { ascending: false })
    return (data || []) as CRMActivity[]
  },
  async upsertActivity(activity: Partial<CRMActivity>): Promise<CRMActivity> {
    const { data, error } = await supabase
      .from('crm_activities')
      .upsert(activity, { onConflict: 'id' })
      .select('*')
      .single()
    if (error) throw error
    return data as CRMActivity
  },
  async deleteActivity(id: string) {
    const { error } = await supabase.from('crm_activities').delete().eq('id', id)
    if (error) throw error
  },

  // Search
  async search(term: string): Promise<CRMSearchItem[]> {
    const { data, error } = await supabase.rpc('crm_search', { term })
    if (error) throw error
    return (data || []) as CRMSearchItem[]
  },
}
